import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import ScrollViewProps from './ScrollViewProps'


export default {
    props: ScrollViewProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoScrollView(this.widgetOptions)
        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoScrollView()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-scrollview-vue-wrapper/src/KendoScrollView/KendoScrollViewMixin.js